import {mapActions} from 'vuex'

const moduleName = 'dashboard'
export default  {
    methods: {
        ...mapActions(moduleName, [
            'addStoreItem'
        ])
    }
}